import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import { generateApplicationUrl } from '@domain-group/javascript-utils'

import { faLink } from '@fortawesome/pro-light-svg-icons'

export const icon = faLink

export const configOptions = () => {}

const generateUrl = (applicationKey: 'engage' | 'template_manager') => {
  // @ts-expect-error TS2339
  const { applicationUrl } = generateApplicationUrl({
    applicationKey,
    // @ts-expect-error TS2322
    environment: process.env.REACT_APP_APPLICATION_ENV,
  })

  return applicationUrl
}

const PlatformLinks = () => (
  <DashboardModule boxProps={{ marginBottom: 0 }} title="Platform Links">
    <Box flexDirection="column" padding="large">
      <Button
        // @ts-expect-error
        as="a"
        buttonStyle="secondaryUtility"
        marginBottom="medium"
        onClick={() => window.location.replace(generateUrl('engage'))}
        size="medium"
      >
        Engage
      </Button>

      <Button
        // @ts-expect-error
        as="a"
        buttonStyle="secondaryUtility"
        onClick={() => window.location.replace(generateUrl('template_manager'))}
        size="medium"
      >
        Template Manager
      </Button>
    </Box>
  </DashboardModule>
)

export default PlatformLinks
